// Worker-side agent call log (GET /api/clients/:id/model-calls, docs/INTERFACES.md 7.2).

import type { ModelCallView } from '@lobby/shared'

/** Thin guard: the endpoint returns `ModelCallView[]`; anything else becomes an empty list. Newest first. */
export function asModelCalls(raw: unknown): ModelCallView[] {
  if (!Array.isArray(raw)) return []
  return (raw as ModelCallView[]).filter((c) => c && typeof c === 'object').sort((a, b) => b.at - a.at)
}
